import { motion } from "framer-motion";
import { forwardRef, useRef } from "react";
import { AnimatedSizeContainerProps } from "./animated-size-container.types";
import { useResizeObserver } from "@/hooks";

const AnimatedSizeContainer = forwardRef<
  HTMLDivElement,
  AnimatedSizeContainerProps
>(
  (
    {
      width = false,
      height = false,
      transition,
      children,
      ...rest
    }: AnimatedSizeContainerProps,
    forwardedRef
  ) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const resizeObserverEntry = useResizeObserver(containerRef);

    return (
      <motion.div
        ref={forwardedRef}
        style={{ overflow: "hidden" }}
        animate={{
          width: width
            ? resizeObserverEntry?.contentRect?.width ?? "auto"
            : "auto",
          height: height
            ? resizeObserverEntry?.contentRect?.height ?? "auto"
            : "auto",
        }}
        transition={transition ?? { type: "spring", duration: 0.3 }}
        {...rest}
      >
        <div
          ref={containerRef}
          style={{
            height: height ? "max-content" : undefined,
            width: width ? "max-content" : undefined,
          }}
        >
          {children}
        </div>
      </motion.div>
    );
  }
);

AnimatedSizeContainer.displayName = "AnimatedSizeContainer";

export { AnimatedSizeContainer };
